import { useModalStore } from "@/stores/use-modal-store";
import { ChartBarIcon, ChartPieIcon, UserGroupIcon, XMarkIcon } from "@heroicons/react/20/solid";
import SceneVisibilityImg from "@/assets/report-assets/scene-visibility-tooltip.png";

/*
 * VisibilityInfoModal component
 *
 * This modal displays information about the Visibility metric.
 */
export const VisibilityInfoModal = () => {
  /* Hooks */
  const { close } = useModalStore((state) => state.modalActions);

  /* Render */
  return (
    <div className="flex flex-col gap-6">
      {/* Header */}
      <div className="flex items-center justify-center relative">
        <h2>Visibility score</h2>
        <XMarkIcon onClick={close} className="size-5 cursor-pointer absolute right-0" />
      </div>

      {/* Image */}
      <div className="flex items-center justify-center">
        <img src={SceneVisibilityImg} alt="Visibility score visualization" className="w-[261px] rounded-lg" />
      </div>

      {/* Description */}
      <p className="text-center">
        Visibility captures overall performance of an individual element likely to get noticed by viewers within a scene. It&apos;s calculated weighing all visibility drivers:
      </p>

      {/* Metrics List */}
      <div className="flex flex-col gap-2">
        {/* POP */}
        <div className="p-4 bg-base-200 rounded-lg">
          <div className="flex items-center gap-2">
            <UserGroupIcon className="size-5 inline-block" />
            <h3 className="font-semibold">POP (Probability of Preception)</h3>
          </div>
          <p className="text-sm opacity-70">What percentage of viewers will notice the AOI at first glance?</p>
        </div>

        {/* SOA */}
        <div className="p-4 bg-base-200 rounded-lg">
          <div className="flex items-center gap-2">
            <ChartPieIcon className="size-5 inline-block" />
            <h3 className="font-semibold">SOA (Share of Attention)</h3>
          </div>
          <p className="text-sm opacity-70">What is the percentage share of attention an AOI received within the asset?</p>
        </div>

        {/* POW */}
        <div className="p-4 bg-base-200 rounded-lg">
          <div className="flex items-center gap-2">
            <ChartBarIcon className="size-5 inline-block" />
            <h3 className="font-semibold">POW (Attention Power Factor)</h3>
          </div>
          <p className="text-sm opacity-70">The amount of attention an AOI receives relative to the amount of space it occupies.</p>
        </div>
      </div>

      {/* Footer Note */}
      <p className="text-sm text-center opacity-70">
        The centre bias is switched off for scene studies as the study aims to evaluate elements performance irrespective of their position in the field of view.
      </p>
    </div>
  );
};
